import { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  addSort,
  addState,
  setPageNumber,
} from "../../redux/SRP/propertiesSlice";
import { fetchStateInitialLoad } from "@/redux/SRP/srpFilterSlice";
import GridListButton from "./GridListButton";
import { useLocation, useParams } from "react-router";
import { ShimmerButton, ShimmerTitle } from "react-shimmer-effects";
import { numCommas } from "@/utils/numCommas";
import { getCampaignDetails } from "@/api/srp";
import FilterMultiItem from "./FilterMultiItem";
import close from "../../../public/assets/images/srp/close.svg";
import downArrow from "../../../public/assets/images/srp/downArrow.svg";
import { Description } from "./Description";
import { trackButtonClick } from "@/utils/analytics";
import {
  trackFilterInteraction,
  getSrpLocationLabel,
} from "@/utils/filterTrackingService";

const FilterTopBar2 = ({ isMobView }) => {
  const {
    sort,
    state,
    campaign,
    campaignId,
    campaignType,
    isPartOfCampaign,
    offers,
    searchBy,
    pageNumber,
    sid,
  } = useSelector((state) => state.properties);
  const stateName = useSelector((state) => state.srp.srpInitData.stateName);
  const city = useSelector((state) => state.srp.srpInitData.city);
  const isSRPLoading = useSelector((state) => state.srp.isSRPLoading);
  const { sortContents, defaultContent, selectedSorting } = useSelector(
    (state) => state.srpFilter.sortFilterConfig,
  );
  const totalResultCount = useSelector(
    (state) => state.srp.srpInitData.totalResultCount,
  );
  const states = useSelector((state) => state.srpFilter.states);
  const sortOptions =
    sortContents?.length > 0 &&
    sortContents.map((sortItem) => ({
      value: sortItem?.sorturl,
      label: sortItem?.displayName,
    }));
  const stateOptions =
    states?.length > 0 &&
    states.map((state) => ({
      value: state?.state,
      label: state?.name === "ALL STATES" ? "All States" : state?.name,
    }));
  const [header, setHeader] = useState({
    title: "",
    description: false,
    isHideAllState: false,
    isHideNearMe: false,
    isHidePrint: false,
    isHideExport: false,
  });
  const [showDescription, setShowDescription] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const stateId = params.stateId;
  const cityId = params.cityId;
  const queryParams = new URLSearchParams(window.location.search);
  const URLState = queryParams.getAll("state");
  if (URLState.length > 0) {
    const stateList = [];
    URLState.map((URL_STA) => {
      let flag = false;
      state?.length > 0 &&
        state.map((STA) => {
          if (URL_STA === STA.value) {
            flag = true;
          }
        });
      if (!flag) {
        states?.length > 0 &&
          states.map((stateItem) => {
            if (URL_STA === stateItem?.state) {
              stateList.push({
                value: stateItem?.state,
                label: stateItem?.name,
              });
            }
          });
      }
    });
    if (stateList.length > 0) {
      dispatch(addState(stateList));
    }
  }
  const URLSort = queryParams.get("sort");
  if (
    URLSort &&
    sort?.value?.length > 0 &&
    sort.value.replace("sort=", "") !== URLSort
  ) {
    sortContents?.length > 0 &&
      sortContents.map((sortItem) => {
        if (URLSort === sortItem?.sorturl.replace("sort=", "")) {
          dispatch(
            addSort({ value: sortItem?.sorturl, label: sortItem?.displayName }),
          );
        }
      });
  }

  useEffect(() => {
    dispatch(fetchStateInitialLoad());
  }, []);

  const setPromotionHeader = async () => {
    if (campaignId) {
      let url = "";
      if (campaign) {
        url = url + `&campaign=${campaign}`;
      }
      if (campaignType) {
        url = url + `&campaignType=${campaignType}`;
      }
      if (isPartOfCampaign) {
        url = url + `&isPartOfCampaign=${isPartOfCampaign}`;
      }
      if (offers) {
        url = url + `&offers=${offers}`;
      }
      if (searchBy) {
        url = url + `&searchBy=${searchBy}`;
      }
      const response = await getCampaignDetails({ campaignId, url });
      const title = response?.campaignImage?.title?.replaceAll('"', "");
      if (title) {
        return {
          title: title,
          description: false,
          isHideAllState: false,
          isHideNearMe: false,
          isHidePrint: false,
          isHideExport: false,
        };
      } else {
        return {
          title: "Real Estate Auctions",
          description: false,
          isHideAllState: false,
          isHideNearMe: false,
          isHidePrint: false,
          isHideExport: false,
        };
      }
    }
  };

  const getHeader = async (pathname) => {
    let header = {
      title: "",
      description: false,
      isHideAllState: false,
      isHideNearMe: false,
      isHidePrint: false,
      isHideExport: false,
    };
    const cityName =
      (city &&
        city
          .split(" ")
          .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
          .join(" ")) ||
      "";
    switch (pathname) {
      case "/auctions":
        if (sid.length > 0 && sid[0] === "offmarket-properties") {
          header.title = "Off-Market homes for sale";
        } else if (sid.length > 0 && sid[0] === "signature-seller") {
          header.title = "Hubzu Signature homes for sale";
        } else {
          header.title = "Real Estate Auctions";
        }
        break;
      case "/bank-owned":
        header.title = "Bank Owned homes for sale";
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/commercial":
        header.title = "Commercial Real Estate";
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/foreclosures":
        header.title = "Foreclosed homes for sale";
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/short-sale":
        header.title = "Short sale homes";
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/traditional-sale":
        header.title = "Homes & Real Estate for Sale";
        header.description = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/near-by":
        header.title = "Real Estate Auctions";
        header.description = false;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case "/near-me":
        header.title = "Auctions near me";
        header.description = true;
        const queryParams = new URLSearchParams(window.location.search);
        const searchBy = queryParams.get("searchBy");
        if (searchBy && searchBy === "All States") {
          header.isHideAllState = false;
          header.isHideNearMe = true;
          header.isHidePrint = true;
          header.isHideExport = true;
        } else {
          header.isHideAllState = true;
          header.isHideNearMe = true;
          header.isHidePrint = true;
          header.isHideExport = true;
        }
        break;
      case "/real-estate-auctions-near-me":
        header.title = "Auctions near me";
        header.description = true;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case "/auctions-near-me":
        header.title = "Auctions near me";
        header.description = true;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case "/foreclosures-near-me":
        header.title = "Foreclosed homes near me";
        header.description = true;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/bank-owned-properties-near-me":
        header.title = "Bank Owned homes near me";
        header.description = true;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/bank-owned-near-me":
        header.title = "Bank Owned homes near me";
        header.description = true;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/short-sale-properties-near-me":
        header.title = "Short sale homes near me";
        header.description = true;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case "/short-sale-near-me":
        header.title = "Short sale homes near me";
        header.description = true;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/${cityId}/auctions`:
        header.title = `Real Estate Auctions in ${cityName}, ${
          stateName || ""
        }`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/allstates/auctions`:
        header.title = `Real Estate Auctions`;
        header.isHideAllState = false;
        header.isHideNearMe = false;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/auctions`:
        header.title = `Real Estate Auctions in ${
          cityName ? `${cityName}, ` : ""
        }${stateName}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/${stateId}/${cityId}/bank-owned`:
        header.title = `Bank Owned homes for sale in ${cityName}, ${
          stateName || ""
        }`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/allstates/bank-owned`:
        header.title = `Bank Owned homes for sale`;
        header.isHideAllState = false;
        header.isHideNearMe = false;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/bank-owned`:
        header.title = `Bank Owned homes for sale in ${
          cityName ? `${cityName}, ` : ""
        }${stateName}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/${cityId}/auctions/condos`:
        header.title = `Condo Auctions & Foreclosure in ${cityName}, ${
          stateName || ""
        }`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/allstates/auctions/condos`:
        header.title = `Condo Auctions & Foreclosure`;
        header.isHideAllState = false;
        header.isHideNearMe = false;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/auctions/condos`:
        header.title = `Condo Auctions & Foreclosure in ${
          cityName ? `${cityName}, ` : ""
        }${stateName}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/${cityId}/foreclosures`:
        header.title = `Foreclosed homes for sale in ${cityName}, ${
          stateName || ""
        }`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/allstates/foreclosures`:
        header.title = `Foreclosed homes for sale`;
        header.isHideAllState = false;
        header.isHideNearMe = false;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/foreclosures`:
        header.title = `Foreclosed homes for sale in ${
          cityName ? `${cityName}, ` : ""
        }${stateName}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/${cityId}/auctions/land`:
        header.title = `Land Auctions & Foreclosure in ${cityName}, ${
          stateName || ""
        }`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/allstates/auctions/land`:
        header.title = `Land Auctions & Foreclosure`;
        header.isHideAllState = false;
        header.isHideNearMe = false;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/auctions/land`:
        header.title = `Land Auctions & Foreclosure in ${
          cityName ? `${cityName}, ` : ""
        }${stateName}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/${cityId}/short-sale`:
        header.title = `Short sale homes in ${cityName}, ${stateName || ""}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/allstates/short-sale`:
        header.title = `Short sale homes`;
        header.isHideAllState = false;
        header.isHideNearMe = false;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/short-sale`:
        header.title = `Short sale homes in ${
          cityName ? `${cityName}, ` : ""
        }${stateName}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/${cityId}/non-bank-owned`:
        header.title = `Non Bank Owned homes for sale in ${cityName}, ${
          stateName || ""
        }`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = false;
        header.isHideExport = false;
        break;
      case `/allstates/non-bank-owned`:
        header.title = `Non Bank Owned homes for sale`;
        header.isHideAllState = false;
        header.isHideNearMe = false;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      case `/${stateId}/non-bank-owned`:
        header.title = `Non Bank Owned homes for sale in ${
          cityName ? `${cityName}, ` : ""
        }${stateName}`;
        header.isHideAllState = true;
        header.isHideNearMe = true;
        header.isHidePrint = true;
        header.isHideExport = true;
        break;
      default:
        header.title = "Real Estate Auctions";
        break;
    }
    if (campaignId) {
      const campaignHeader = await setPromotionHeader();
      setHeader(campaignHeader);
    } else if (isPartOfCampaign === "Y") {
      header.title = "Home Auctions & Real Estate Auctions";
      setHeader(header);
    } else {
      setHeader(header);
    }
  };

  useEffect(() => {
    getHeader(pathname);
  }, [pathname, stateName, city, campaignId, isPartOfCampaign, sid]);

  useEffect(() => {
    if (pathname.includes("near-me")) {
      dispatch(
        addSort({ value: "sort=Distance", label: "Distance (Near to far)" }),
      );
    }
  }, [pathname]);

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img
          src={downArrow}
          height={12}
          width={12}
          className="cursor-pointer"
          alt="arrow"
        />
      </components.DropdownIndicator>
    );
  };

  // add default sort
  // useEffect(() => {
  //   if (selectedSorting?.sorturl || defaultContent?.sorturl) {
  //     dispatch(addSort(selectedSorting?.sorturl ? {value: selectedSorting?.sorturl, label: selectedSorting?.displayName} : {value: defaultContent?.sorturl, label: defaultContent?.displayName}));
  //   }
  // }, [dispatch, selectedSorting?.sorturl, defaultContent?.sorturl]);
  const offerBanners = {
    "LOW-STARTING-BID": {
      key: "LOW-STARTING-BID",
      src: "https://image-prod.hubzu.com/campaign/HU303-low-starting-bid-SRP-Ad-B.jpg",
      alt: "low-starting-bid-banner",
    },
    reduced_reserve: {
      key: "reduced_reserve",
      src: "https://image-prod.hubzu.com/campaign/HU309-reduced-reserve-SRP-C.jpg",
      alt: "reduced-reserve-banner",
    },
    "buyers-premium-reduction": {
      key: "buyers-premium-reduction",
      src: "https://image-prod.hubzu.com/campaign/HU492_srp_banner.jpg",
      alt: "reduced-reserve-banner",
      href: "/buyers-premium-reduction",
      target: "_blank",
    },
    CYBER_MONDAY: {
      key: "CYBER_MONDAY",
      src: "https://image-prod.hubzu.com/campaign/hubzu-cyber-monday-2022-SRP-banner.png",
      alt: "cyber-monday-banner",
      href: "/cybermonday",
      target: "_blank",
    },
  };
  return (
    <>
      {campaignId && campaignType && offers && (
        <div className="col-sm-12 col-md-12 justify-content-center pl7">
          {offers && offerBanners[offers] && (
            <div className="low-starting-bid">
              <a
                href={offerBanners[offers]?.href}
                target={offerBanners[offers]?.target}
              >
                <img
                  className="low-starting-bid-banner"
                  src={offerBanners[offers]?.src}
                  alt={offerBanners[offers]?.alt}
                />
              </a>
            </div>
          )}
        </div>
      )}
      <div className="col-sm-12 col-md-6 justify-content-center pl7">
        {!isSRPLoading && isMobView ? (
          <div
            className={`left_area ${isMobView ? "pr65 pb15" : ""}`}
            style={{ position: "fixed", zIndex: 11 }}
          >
            <div
              className="m0 srp-result-font"
              tabIndex="0"
              style={{ marginTop: -6.5 }}
            >
              <span>{`Sort by`}</span>
              <div className="mr0 list-inline-item pr0 cursor-pointer">
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={
                    pathname.includes("near-me")
                      ? sortOptions
                      : sortOptions?.length > 0 && sortContents?.length > 0
                        ? sortOptions?.slice(0, sortContents?.length - 1)
                        : sortOptions
                  }
                  aria-label="react-select-sort"
                  value={sort}
                  placeholder="Sort by:"
                  isSearchable={false}
                  components={{ DropdownIndicator }}
                  onMenuOpen={() => {
                    // Track dropdown open event
                    trackButtonClick({
                      eventName: "sort_button_click",
                      eventSource: "Dropdown Open",
                      eventCategory: "NEW-SRP",
                      eventLabel: "Status: open",
                    });
                  }}
                  onChange={(item) => {
                    // Track item select event
                    trackButtonClick({
                      eventName: "sort_selection",
                      eventSource: "Dropdown Selection",
                      eventCategory: "NEW-SRP",
                      eventLabel: `Sort by: ${item?.label || "Unknown"}`,
                    });
                    //update Addressbar
                    let addressBarURL = new URL(window.location.href);
                    if (addressBarURL.searchParams.has("sort")) {
                      addressBarURL.searchParams.delete("sort");
                      addressBarURL.searchParams.append(
                        "sort",
                        item?.value?.replace("sort=", ""),
                      );
                      history.pushState({}, "", addressBarURL.href);
                    } else {
                      addressBarURL.searchParams.append(
                        "sort",
                        item?.value?.replace("sort=", ""),
                      );
                      history.pushState({}, "", addressBarURL.href);
                    }
                    //update Redux
                    if (pageNumber !== 1) dispatch(setPageNumber(1));
                    dispatch(addSort(item));

                    // Track via filter interaction API
                    trackFilterInteraction("FILTER_SELECTED");
                  }}
                />
              </div>
            </div>
          </div>
        ) : null}
        {!isSRPLoading ? (
          <div className={`left_area ${isMobView ? "pr0 pt60" : ""}`}>
            <div className="m0 srp-title-container" tabIndex="0">
              <span className="srp-title">{header.title} </span>
              <div className="srp-sub-title-container">
                {!header?.isHideAllState ? (
                  <span className="srp-title-support">in</span>
                ) : (
                  <div className="srp-hide-all-state" />
                )}
                {!header?.isHideAllState && stateOptions?.length > 0 && (
                  <FilterMultiItem
                    panelId={"state-list"}
                    key={"state-multi-select-list"}
                    propertyName={"All States"}
                    propertiesItem={stateOptions}
                    selectedList={state}
                    onClick={(item) => {
                      //update Addressbar
                      let addressBarURL = new URL(window.location.href);
                      addressBarURL.searchParams.delete("state");
                      item.length > 0 &&
                        item.map((stateItem) => {
                          if (stateItem?.value !== "0000000") {
                            addressBarURL.searchParams.append(
                              "state",
                              stateItem.value,
                            );
                          }
                        });

                      const stateValues = item
                        .map((stateItem) => stateItem.value)
                        .join(",");
                      // Build location from the applied selection (`item`) rather than
                      // Redux, which is not yet updated (dispatch(addState) runs below).
                      const stateLocation = item
                        .map((stateItem) => stateItem.label || stateItem.value)
                        .filter(Boolean)
                        .join(",");

                      trackButtonClick({
                        eventName: "filter_toggle",
                        eventParams: { action: "selected", filter_type: "state" },
                        eventSource: "SRP FILTERS",
                        eventCategory: "NEW-SRP",
                        eventLabel: `State Selected: ${stateValues} | Location: ${stateLocation}`,
                      });

                      history.pushState({}, "", addressBarURL.href);
                      //update Redux
                      if (pageNumber !== 1) dispatch(setPageNumber(1));
                      dispatch(addState(item));

                      // Track via filter interaction API
                      trackFilterInteraction("FILTER_SELECTED");
                    }}
                  />
                )}
              </div>
            </div>
            <div
              className="m0 srp-result-font"
              tabIndex="0"
              style={{
                marginTop: isMobView ? 0 : -6.5,
                paddingBottom: isMobView ? 15 : 0,
              }}
            >
              {!totalResultCount || totalResultCount === 0 ? (
                <span style={{ lineHeight: 1.8 }}>{`0`} Results</span>
              ) : (
                <span>
                  {`${
                    totalResultCount > 10000
                      ? "10000+"
                      : numCommas(totalResultCount)
                  } ${isMobView ? "Results" : "Results, sorted by"}`}
                </span>
              )}
              {!isMobView && totalResultCount && totalResultCount !== 0 ? (
                <div className="mr0 list-inline-item pr0 cursor-pointer">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={
                      pathname.includes("near-me")
                        ? sortOptions
                        : sortOptions?.length > 0 && sortContents?.length > 0
                          ? sortOptions?.slice(0, sortContents?.length - 1)
                          : sortOptions
                    }
                    aria-label="react-select-sort"
                    value={sort}
                    placeholder="Sort by:"
                    isSearchable={false}
                    components={{ DropdownIndicator }}
                    onMenuOpen={() => {
                      // Track dropdown open event
                      trackButtonClick({
                        eventName: "sort_button_click",
                        eventSource: "Dropdown Open",
                        eventCategory: "NEW-SRP",
                        eventLabel: "Status: open",
                      });
                    }}
                    onChange={(item) => {
                      // Track item select event
                      trackButtonClick({
                        eventName: "sort_selection",
                        eventSource: "Dropdown Selection",
                        eventCategory: "NEW-SRP",
                        eventLabel: `Sort by: ${item?.label || "Unknown"}`,
                      });
                      //update Addressbar
                      let addressBarURL = new URL(window.location.href);
                      if (addressBarURL.searchParams.has("sort")) {
                        addressBarURL.searchParams.delete("sort");
                        addressBarURL.searchParams.append(
                          "sort",
                          item?.value?.replace("sort=", ""),
                        );
                        history.pushState({}, "", addressBarURL.href);
                      } else {
                        addressBarURL.searchParams.append(
                          "sort",
                          item?.value?.replace("sort=", ""),
                        );
                        history.pushState({}, "", addressBarURL.href);
                      }
                      //update Redux
                      if (pageNumber !== 1) dispatch(setPageNumber(1));
                      dispatch(addSort(item));

                      // Track via filter interaction API
                      trackFilterInteraction("FILTER_SELECTED");
                    }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <div>
            <ShimmerTitle line={2} gap={10} variant="primary" />
          </div>
        )}
      </div>
      {/* End .col */}
      {!isSRPLoading ? (
        <div
          className={`col-sm-12 col-md-6 d-flex justify-content-end ${isMobView ? "pr10" : ""}`}
        >
          <GridListButton
            isResult={totalResultCount !== 0}
            isMain={false}
            isHideNearMe={header?.isHideNearMe}
            isHidePrint={isMobView ? true : header?.isHidePrint}
            isHideExport={isMobView ? true : header?.isHideExport}
          />
        </div>
      ) : (
        <div className="col-md-6 justify-content-end row">
          <ShimmerButton size="md" />
        </div>
      )}
      {!isSRPLoading && header?.description && (
        <div className="d-flex justify-content-start mt15 pl7 pb0">
          <span className="srp-description">
            {Description[pathname]?.shortDescription}{" "}
            {!showDescription && (
              <span
                className="read-more-link"
                onClick={() => setShowDescription(true)}
              >
                Read more
              </span>
            )}
            {showDescription && (
              <span style={{ whiteSpace: "pre-line" }} onClick={() => {}}>
                {Description[pathname]?.fullDescription}{" "}
              </span>
            )}
            {showDescription && (
              <span
                className="read-more-link"
                onClick={() => setShowDescription(false)}
              >
                Read less
              </span>
            )}
          </span>
        </div>
      )}
      {!isSRPLoading && pathname.includes("near-by") ? (
        <span className="srp-title pt30">Recommended Properties</span>
      ) : (
        !isSRPLoading &&
        state?.length > 0 && (
          <div className="selected-state-list">
            {state.map((stateItem) => (
              <div className="state-bread-crumb">
                <span>{stateItem?.label}</span>
                <button
                  className="remove-state"
                  onClick={() => {
                    const filteredList = state.filter(
                      (s) => s?.value !== stateItem?.value,
                    );
                    //update Addressbar
                    let addressBarURL = new URL(window.location.href);
                    addressBarURL.searchParams.delete("state");
                    filteredList.length > 0 &&
                      filteredList.map((item) => {
                        addressBarURL.searchParams.append("state", item.value);
                      });
                    history.pushState({}, "", addressBarURL.href);
                    //update Redux
                    dispatch(addState(filteredList));

                    // Track via filter interaction API
                    trackFilterInteraction("FILTER_DESELECTED", {
                      deselectedFilters: `state=${stateItem.value}`,
                    });

                    trackButtonClick({
                      eventName: "filter_toggle",
                      eventParams: { action: "deselected", filter_type: "state" },
                      eventSource: "SRP FILTERS",
                      eventCategory: "NEW-SRP",
                      eventLabel: `State Deselected: ${stateItem.value} | Location: ${getSrpLocationLabel()}`,
                    });
                  }}
                >
                  <img src={close} height={10} width={11} alt="close" />
                </button>
              </div>
            ))}
          </div>
        )
      )}
    </>
  );
};

export default FilterTopBar2;
